"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _merge = _interopRequireDefault(require("../../../utilities/merge"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var inputBase = {
  border: '1px solid',
  borderColor: 'slategrey',
  borderRadius: 0,
  width: '100%',
  py: '3',
  px: '4',
  fontSize: '4',
  color: 'black',
  lineHeight: 'inherit',
  '::placeholder': {
    color: 'browngrey'
  },
  '&:focus': {
    borderColor: 'orange',
    outline: 'none',
    '::placeholder': {
      color: 'transparent'
    }
  }
};
var input = inputBase;
var select = (0, _merge.default)(inputBase, {
  pr: '44px',
  openIcon: {
    right: '16px'
  }
});
var _default = {
  label: {},
  error: {},
  group: {},
  hint: {},
  input: input,
  password: {
    input: input,
    toggleButton: {
      '&:focus': {
        '& svg': {
          outline: '1px dotted',
          outlineColor: 'slategrey',
          outlineOffset: '2px'
        }
      }
    }
  },
  select: select,
  multiselect: input,
  textarea: (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
    maxWidth: '100%'
  }),
  radio: {
    color: 'rgba(0, 0, 0, 0.54)',
    '&:focus': {
      outline: 'none'
    },
    '&:checked': {
      color: 'orange'
    }
  },
  slider: {
    color: 'orange',
    backgroundColor: 'browngrey'
  },
  checkbox: {
    color: 'rgba(0, 0, 0, 0.54)',
    borderRadius: '2px',
    fontWeight: 'bold',
    '&:checked': {
      color: 'orange'
    },
    '&:focus + label': {
      borderBottom: '1px solid',
      borderColor: 'orange'
    }
  },
  toggle: {},
  summary: {
    summary: {
      p: '4',
      mb: '2',
      backgroundColor: '#ececec'
    },
    links: {
      fontSize: '4',
      mb: '1'
    },
    list: {
      marginBottom: 0,
      listStyleType: 'disc',
      flexDirection: 'column',
      listStylePosition: 'inside'
    },
    item: {
      listStyleType: 'inherit',
      margin: 0
    },
    header: {
      fontSize: '5',
      fontWeight: 'bold',
      mb: '2'
    }
  }
};
exports.default = _default;